// import PlayerEvent from '../events/player.event';

export default class PlaylistDataModel {
  constructor(playlistDataParsed, loopEnabled, publihserId) {
    this.playlistData = playlistDataParsed;
    this.indexSelected = 0;
    this.loopEnabled = loopEnabled;
    this.videoProducerItem = this.playlistData
      .filter((item) => typeof item.urlVideoProducer !== 'undefined')
      .shift();
    this.pubId = publihserId || 0;
    this.looped = false;
    this.isPlaylist = playlistDataParsed?.length > 1;
  }

  getItemSelected() {
    return this.playlistData[this.indexSelected];
  }

  getNextItem() {
    if (this.isNextItem()) {
      this.indexSelected += 1;
      return this.getItemSelected();
    }
    if (this.loopEnabled) {
      this.looped = true;
      this.indexSelected = 0;
      return this.getItemSelected();
    }
    return false;
  }

  getPreviousItem() {
    if (this.isPreviousItem()) {
      this.indexSelected -= 1;
      return this.getItemSelected();
    }
    if (this.loopEnabled) {
      this.indexSelected = this.playlistData.length - 1;
      return this.getItemSelected();
    }

    return false;
  }

  isNextItem() {
    if (this.indexSelected < this.playlistData.length - 1) return this.indexSelected + 1;
    return 0;
  }

  isPreviousItem() {
    return this.indexSelected !== 0;
  }

  goToIndex(index) {
    if (Number.isInteger(index) && index >= 0 && index < this.playlistData.length) {
      this.indexSelected = index;
      return this.getItemSelected();
    }
    return false;
  }

  getTotalItems() {
    return this.playlistData.length || 0;
  }

  isVideoProducer() {
    return this.videoProducerItem;
  }

  setUrlVideoForVideoProducer(urlVideo) {
    this.playlistData.find((item) => {
      if (item.urlVideoProducer) {
        // eslint-disable-next-line no-param-reassign
        item.url = urlVideo;
      }
      return item;
    });
  }

  setVideoProducerModel(videoProducerModel) {
    this.videoProducerModel = videoProducerModel;
  }

  get publisherId() {
    return this.pubId;
  }
}
